import { Tooltip } from 'react-tooltip'
import "./ToolTipFiliaisDesabilitadas.css"

import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

function ToolTipFiliaisDesabilitadas({ filiais, todas }) {
 
    function TableFiliaisToolTip({ filiais }) {
        return (
        <Tooltip 
            anchorSelect=".anchor-filiais-desabilitadas" 
            place="bottom" 
            style={{
                zIndex: "9999",
                borderRadius: "10px",
                backgroundColor: "white"
            }}
            border="1px solid #DCDCDC"
            opacity={1}
            clickable
        >
            <div className='filiais-desativadas-tooltip'>
                <h1>Filiais desabilitadas</h1>
                <div className='table-wrapper'>
                    <table className='adm-table'>
                        <thead><tr>
                            <th>Código</th>
                            <th>Nome</th>
                        </tr></thead>
                        <tbody>
                            {filiais.map(filial => (
                                <tr className="adm-table-row">
                                    <td>{filial.idfilial - 10000}</td>
                                    <td>{filial.filial_nome}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Tooltip>
        )
    }

    return (
        <>
            <div className="anchor-filiais-desabilitadas">
                <PriorityHighIcon style={{width: '40px', height: '40px', marginRight: '2px'}} />
                {todas
                    ? "Todas as filiais selecionadas estão com este indicador desabilitado"
                    : filiais.length === 1 
                    ? `Existe uma filial com este indicador desabilitado`
                    : `Existem ${filiais.length} filiais com este indicador desabilitado`
                }
            </div>
            <TableFiliaisToolTip filiais={filiais}/>
        </>
    )
}

export default ToolTipFiliaisDesabilitadas